import classes from "../../../scss/ListWrapper.module.scss";

export default function ListWrapper({ children, className = "" }) {
  return <div className={`${classes.wrapper} ${className}`}>{children}</div>;
}
